// Complete export service - SYNTAX FIXED
import { Document, Paragraph, TextRun, HeadingLevel, AlignmentType, Packer } from 'docx';
import { jsPDF } from 'jspdf';

export const exportToTXT = (chat) => {
  let text = '╔════════════════════════════════════════╗\n';
  text += '║  BABA AI - CHAT EXPORT                ║\n';
  text += '╚════════════════════════════════════════╝\n\n';
  
  text += 'Chat Name: ' + chat.name + '\n';
  text += 'Created: ' + new Date(chat.createdAt).toLocaleString() + '\n';
  text += 'Last Updated: ' + new Date(chat.updatedAt).toLocaleString() + '\n';
  text += 'Total Messages: ' + chat.messages.length + '\n';
  text += '\n' + '═'.repeat(60) + '\n\n';
  
  chat.messages.forEach((msg, idx) => {
    const timestamp = new Date(msg.timestamp).toLocaleString();
    const role = msg.role === 'user' ? 'YOU' : 'BABA AI';
    
    text += '[' + (idx + 1) + '] ' + role + ' - ' + timestamp + '\n';
    text += '─'.repeat(60) + '\n';
    text += msg.content + '\n';
    
    if (msg.files && msg.files.length > 0) {
      text += '\nAttachments:\n';
      msg.files.forEach(f => {
        text += '  📎 ' + f.name + '\n';
      });
    }
    
    text += '\n' + '═'.repeat(60) + '\n\n';
  });
  
  text += '\nExported: ' + new Date().toLocaleString() + '\n';
  text += 'Total characters: ' + text.length + '\n';
  
  return text;
};

export const exportToJSON = (chat) => {
  const exportData = {
    metadata: {
      exportedAt: new Date().toISOString(),
      chatName: chat.name,
      chatId: chat.id,
      createdAt: chat.createdAt,
      updatedAt: chat.updatedAt,
      totalMessages: chat.messages.length,
      version: '1.0'
    },
    chat: {
      id: chat.id,
      name: chat.name,
      createdAt: chat.createdAt,
      updatedAt: chat.updatedAt,
      messages: chat.messages.map((msg, idx) => ({
        index: idx + 1,
        role: msg.role,
        content: msg.content,
        timestamp: msg.timestamp,
        files: msg.files || []
      }))
    }
  };
  
  return JSON.stringify(exportData, null, 2);
};

export const exportToMarkdown = (chat) => {
  let md = '# 🖤 ' + chat.name + '\n\n';
  
  md += '> **Baba AI Chat Export**\n';
  md += '> \n';
  md += '> - **Created:** ' + new Date(chat.createdAt).toLocaleString() + '\n';
  md += '> - **Last Updated:** ' + new Date(chat.updatedAt).toLocaleString() + '\n';
  md += '> - **Messages:** ' + chat.messages.length + '\n';
  md += '> - **Exported:** ' + new Date().toLocaleString() + '\n\n';
  
  md += '---\n\n';
  
  chat.messages.forEach((msg, idx) => {
    const timestamp = new Date(msg.timestamp).toLocaleString();
    
    if (msg.role === 'user') {
      md += '## 👤 You\n';
      md += '*' + timestamp + '*\n\n';
      md += msg.content + '\n\n';
    } else {
      md += '## 🤖 Baba AI\n';
      md += '*' + timestamp + '*\n\n';
      md += msg.content + '\n\n';
    }
    
    if (msg.files && msg.files.length > 0) {
      md += '**Attachments:**\n';
      msg.files.forEach(f => {
        md += '- 📎 ' + f.name + '\n';
      });
      md += '\n';
    }
    
    if (idx < chat.messages.length - 1) {
      md += '---\n\n';
    }
  });
  
  return md;
};

export const exportToHTML = (chat) => {
  const escapeHtml = (text) => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  let html = '<!DOCTYPE html>\n<html lang="en">\n<head>\n';
  html += '  <meta charset="UTF-8">\n';
  html += '  <meta name="viewport" content="width=device-width, initial-scale=1.0">\n';
  html += '  <title>' + chat.name + ' - Baba AI Export</title>\n';
  html += '  <style>\n';
  html += '    * { margin: 0; padding: 0; box-sizing: border-box; }\n';
  html += '    body { font-family: sans-serif; background: #0a0a0a; color: #e0e0e0; padding: 40px 20px; line-height: 1.6; }\n';
  html += '    .container { max-width: 900px; margin: 0 auto; }\n';
  html += '    .header { text-align: center; padding: 40px 20px; background: #1a1a1a; border-radius: 12px; margin-bottom: 40px; border: 1px solid #2a2a2a; }\n';
  html += '    .header h1 { font-size: 32px; margin-bottom: 20px; }\n';
  html += '    .metadata { color: #888; font-size: 14px; }\n';
  html += '    .message { margin-bottom: 30px; padding: 20px; background: #1a1a1a; border-radius: 12px; border: 1px solid #2a2a2a; }\n';
  html += '    .message-header { display: flex; justify-content: space-between; margin-bottom: 15px; padding-bottom: 10px; border-bottom: 1px solid #2a2a2a; }\n';
  html += '    .role { font-weight: 600; font-size: 16px; }\n';
  html += '    .role.user { color: #3b82f6; }\n';
  html += '    .role.assistant { color: #10b981; }\n';
  html += '    .message-content { white-space: pre-wrap; word-wrap: break-word; }\n';
  html += '    .attachment { display: inline-block; padding: 4px 10px; background: rgba(59, 130, 246, 0.2); border: 1px solid #3b82f6; border-radius: 12px; font-size: 12px; color: #3b82f6; margin-right: 8px; }\n';
  html += '  </style>\n';
  html += '</head>\n<body>\n';
  html += '  <div class="container">\n';
  html += '    <div class="header">\n';
  html += '      <h1>🖤 ' + chat.name + '</h1>\n';
  html += '      <div class="metadata">\n';
  html += '        <div>Created: ' + new Date(chat.createdAt).toLocaleString() + '</div>\n';
  html += '        <div>Messages: ' + chat.messages.length + '</div>\n';
  html += '      </div>\n';
  html += '    </div>\n';

  chat.messages.forEach((msg) => {
    const timestamp = new Date(msg.timestamp).toLocaleString();
    const roleClass = msg.role === 'user' ? 'user' : 'assistant';
    const roleLabel = msg.role === 'user' ? '👤 You' : '🤖 Baba AI';
    
    html += '    <div class="message">\n';
    html += '      <div class="message-header">\n';
    html += '        <div class="role ' + roleClass + '">' + roleLabel + '</div>\n';
    html += '        <div>' + timestamp + '</div>\n';
    html += '      </div>\n';
    html += '      <div class="message-content">' + escapeHtml(msg.content) + '</div>\n';
    
    if (msg.files && msg.files.length > 0) {
      html += '      <div>';
      msg.files.forEach(f => {
        html += '<span class="attachment">📎 ' + escapeHtml(f.name) + '</span>';
      });
      html += '</div>\n';
    }
    html += '    </div>\n';
  });

  html += '  </div>\n</body>\n</html>';
  return html;
};

export const exportToCSV = (chat) => {
  let csv = 'Index,Role,Timestamp,Content,Attachments\n';
  
  chat.messages.forEach((msg, idx) => {
    const role = msg.role;
    const timestamp = new Date(msg.timestamp).toLocaleString();
    const content = msg.content.replace(/"/g, '""').replace(/\n/g, ' ');
    const attachments = msg.files ? msg.files.map(f => f.name).join('; ') : '';
    
    csv += (idx + 1) + ',"' + role + '","' + timestamp + '","' + content + '","' + attachments + '"\n';
  });
  
  return csv;
};

export const exportToDOCX = async (chat) => {
  const doc = new Document({
    sections: [{
      properties: {},
      children: [
        new Paragraph({
          text: chat.name,
          heading: HeadingLevel.HEADING_1,
          alignment: AlignmentType.CENTER,
          spacing: { after: 400 }
        }),
        
        new Paragraph({
          children: [
            new TextRun({
              text: 'Created: ' + new Date(chat.createdAt).toLocaleString(),
              italics: true,
              size: 20
            })
          ],
          alignment: AlignmentType.CENTER
        }),
        new Paragraph({
          children: [
            new TextRun({
              text: 'Messages: ' + chat.messages.length,
              italics: true,
              size: 20
            })
          ],
          alignment: AlignmentType.CENTER,
          spacing: { after: 400 }
        }),
        
        ...chat.messages.flatMap((msg) => {
          const timestamp = new Date(msg.timestamp).toLocaleString();
          const roleLabel = msg.role === 'user' ? 'You' : 'Baba AI';
          
          const paragraphs = [
            new Paragraph({
              children: [
                new TextRun({
                  text: roleLabel + ' - ' + timestamp,
                  bold: true,
                  size: 22,
                  color: msg.role === 'user' ? '3b82f6' : '10b981'
                })
              ],
              spacing: { before: 300, after: 100 }
            }),
            new Paragraph({
              text: msg.content,
              spacing: { after: 200 }
            })
          ];
          
          if (msg.files && msg.files.length > 0) {
            paragraphs.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: 'Attachments: ' + msg.files.map(f => f.name).join(', '),
                    italics: true,
                    size: 20,
                    color: '666666'
                  })
                ],
                spacing: { after: 200 }
              })
            );
          }
          
          return paragraphs;
        }),
        
        new Paragraph({
          children: [
            new TextRun({
              text: 'Exported from Baba AI - ' + new Date().toLocaleString(),
              italics: true,
              size: 18,
              color: '888888'
            })
          ],
          alignment: AlignmentType.CENTER,
          spacing: { before: 400 }
        })
      ]
    }]
  });

  return await Packer.toBlob(doc);
};

export const exportToPDF = (chat) => {
  const doc = new jsPDF();
  let yPos = 20;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 20;
  const maxWidth = 170;
  
  doc.setFontSize(20);
  doc.setFont(undefined, 'bold');
  doc.text(chat.name, margin, yPos);
  yPos += 15;
  
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.text('Created: ' + new Date(chat.createdAt).toLocaleString(), margin, yPos);
  yPos += 6;
  doc.text('Messages: ' + chat.messages.length, margin, yPos);
  yPos += 15;
  
  chat.messages.forEach((msg) => {
    const timestamp = new Date(msg.timestamp).toLocaleString();
    const roleLabel = msg.role === 'user' ? 'YOU' : 'BABA AI';
    
    if (yPos > pageHeight - 40) {
      doc.addPage();
      yPos = 20;
    }
    
    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.setTextColor(msg.role === 'user' ? 59 : 16, msg.role === 'user' ? 130 : 185, msg.role === 'user' ? 246 : 129);
    doc.text(roleLabel + ' - ' + timestamp, margin, yPos);
    yPos += 8;
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.setTextColor(0, 0, 0);
    
    const lines = doc.splitTextToSize(msg.content, maxWidth);
    lines.forEach(line => {
      if (yPos > pageHeight - 20) {
        doc.addPage();
        yPos = 20;
      }
      doc.text(line, margin, yPos);
      yPos += 6;
    });
    
    if (msg.files && msg.files.length > 0) {
      yPos += 3;
      doc.setFontSize(9);
      doc.setTextColor(100, 100, 100);
      doc.text('Attachments: ' + msg.files.map(f => f.name).join(', '), margin, yPos);
      yPos += 6;
    }
    
    yPos += 8;
  });
  
  doc.setFontSize(8);
  doc.setTextColor(150, 150, 150);
  if (yPos > pageHeight - 30) {
    doc.addPage();
    yPos = 20;
  }
  doc.text('Exported from Baba AI - ' + new Date().toLocaleString(), margin, yPos);
  
  return doc.output('blob');
};

export const downloadFile = (content, filename, mimeType = 'text/plain') => {
  const blob = content instanceof Blob ? content : new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
